import Api from '@op/opds.api-base';
import log from '@op/opds.api-base/log';

class RestApi {
  constructor() {
    this.activeRequests = {};
    // Rest URL is set in index.html so RD Proxy can modify it
    this._api = new Api(window.INSURANCE_OFFER_REQUEST_SUBMIT_URL);
    this._api.defaultHeaders.set('Accept', 'application/json');
    this._api.defaultHeaders.set('Content-Type', 'application/json');

    // Register error logging
    // Do not run .install() on logger - otherwise it will also report all uncaught errors, including other applications on page
    this.logger = log.config(this._api);
  }

  getCurrentRequest = (url, apiRequest) => {
    if (!this.activeRequests[url]) {
      this.activeRequests[url] = apiRequest().then(
        (response) => {
          if (response?.token || response?.status === 'OK') {
            return response;
          }
          delete this.activeRequests[url];
        },
        () => {
          delete this.activeRequests[url];
        }
      );
    }
    return this.activeRequests[url];
  };

  getCsrfToken = async () => {
    const url = '/csrftokens';

    const apiRequest = async () => {
      return this._api.get(url);
    };

    return this.getCurrentRequest(url, apiRequest);
  };

  makeHeader = async () => {
    const response = await this.getCsrfToken();
    const { token, headerName } = response || { token: '', headerName: '' };
    return {
      ...(token ? { [headerName]: token } : {}),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };
  };

  userContext = async () => {
    const url = '/rest/userContext';
    const headers = await this.makeHeader();

    const apiRequest = async () => {
      return this._api.get(url, { headers });
    };

    return this.getCurrentRequest(url, apiRequest);
  };

  processSurvey = async (requestBody) => {
    const url = '/rest/processSurvey';
    const headers = await this.makeHeader();

    const apiRequest = async () => {
      return this._api.post(url, {
        body: JSON.stringify(requestBody),
        headers,
        timeout: 15000,
        ignoreErrorHandling: false,
        errorCode: 'IO003',
      });
    };

    return this.getCurrentRequest(url, apiRequest);
  };

  customerSearch = async (requestBody) => {
    const url = '/rest/insurance/offer/request/customer';
    const headers = await this.makeHeader();

    const apiRequest = async () => {
      return this._api.post(url, {
        body: JSON.stringify(requestBody),
        headers,
        timeout: 15000
      });
    };

    return this.getCurrentRequest(url, apiRequest);
  };
}

// eslint-disable-next-line
export default new RestApi();
